import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Header } from "./components/header/header";
import { Greetings } from "./pages/greetings";
import { Questions } from "./pages/questions";
import { SkinNames } from "./pages/skin-names";
import { SelectRoute } from "./components/select/select";

function App() {
  return (
    <div id="app">
      <Header />
      <div id="content">
        <p>
          This is probably not the phrasebook you're looking for! The new
          version is at{" "}
          <a href="https://www.njamed.com/phrasebook">
            https://www.njamed.com/phrasebook
          </a>
        </p>
        <Router>
          <SelectRoute />

          <Switch>
            <Route exact={true} path="/">
              <Greetings />
            </Route>
            <Route exact={true} path="/greetings">
              <Greetings />
            </Route>
            <Route exact={true} path="/questions">
              <Questions />
            </Route>
            <Route exact={true} path="/skin-names">
              <SkinNames />
            </Route>
          </Switch>
        </Router>
      </div>
    </div>
  );
}

export default App;
